class holidaysSchedule {
      constructor(id, name) {
        this.id = id;
        this.name = name;
      }
      static fromJson({ tipoFerId, nomTipoFer }) {
        return new holidaysSchedule(tipoFerId, nomTipoFer);
      }
    }
    export default holidaysSchedule;
    